export default __webpack_public_path__ + "static/media/fieldcuts6_3.5e98df01.jpg";